import React from 'react';

import styles from './styles.module.scss';

interface Props {
  capsLetterFlag: string;
  numberFlag: string;
  pwdLengthFlag: string;
  specialFlag: string;
  fontSize?: string;
}

const PWDRequisite: React.FC<Props> = ({
  capsLetterFlag,
  numberFlag,
  pwdLengthFlag,
  specialFlag,
  fontSize = '16px',
}): JSX.Element => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }} className="fs-unmask">
    <span className={styles.spanText}>Your password must have</span>
    <span className={styles.validationPoints}>
      <input
        type="checkbox"
        id="accessCode"
        checked={pwdLengthFlag === 'valid'}
        className={`form-check-input  fs-exclude ${styles.isTermAcceptedInput} fs-unmask 
                      }`}
        disabled
      />
      <label className={`${styles.isTermAcceptedLabel} fs-unmask`} htmlFor="accessCode" style={{ fontSize }}>
        8 characters
      </label>
    </span>
    <span className={styles.validationPoints}>
      <input
        type="checkbox"
        id="accessCode"
        checked={capsLetterFlag === 'valid'}
        className={`form-check-input  fs-exclude ${styles.isTermAcceptedInput} fs-unmask 
                      }`}
        disabled
      />
      <label className={`${styles.isTermAcceptedLabel} fs-unmask`} htmlFor="accessCode" style={{ fontSize }}>
        1 uppercase letter
      </label>
    </span>
    <span className={styles.validationPoints}>
      <input
        type="checkbox"
        id="accessCode"
        checked={numberFlag === 'valid'}
        className={`form-check-input fs-exclude ${styles.isTermAcceptedInput} fs-unmask 
                      }`}
        disabled
      />
      <label className={`${styles.isTermAcceptedLabel} fs-unmask`} htmlFor="accessCode" style={{ fontSize }}>
        1 number
      </label>
    </span>
    <span className={styles.validationPoints}>
      <input
        type="checkbox"
        id="accessCode"
        checked={specialFlag === 'valid'}
        className={`form-check-input  fs-exclude ${styles.isTermAcceptedInput} fs-unmask 
                      }`}
        disabled
      />
      <label className={`${styles.isTermAcceptedLabel} fs-unmask`} htmlFor="accessCode" style={{ fontSize }}>
        1 symbol
      </label>
    </span>
  </div>
);

export default PWDRequisite;
